import { AuthTokenResponse, LoginResponse } from "../../../types/auth.types";
import { setAccessToken } from "../../../utils/authTokenStore";
import { saveCompanyTenantId, saveTenantId, saveUserTenantId } from "../../../utils/cacheStorage";

// Company resolution lives in `src/utils/utils.ts` (shared with the legacy
// login screens); re-exported here so the auth flow imports it from one place.
// Token persistence below is still duplicated in the legacy Login/CognitoLogin
// screens until the `ENABLE_AUTH_UI_REDESIGN` flag is removed.
export { resolveUserCompany } from "../../../utils/utils";
export type { ResolvedCompany } from "../../../utils/utils";

/**
 * Stores the access token from a successful `POST auth/login` in memory. The
 * refresh token is never visible to the client (httpOnly cookie) -- see
 * `docs/NPCW-2918-secure-token-storage.md`.
 */
export const persistLoginTokens = (response: LoginResponse): void => {
  setAccessToken(response.token);
};

/**
 * Stores the access token and tenant ids from a successful
 * `POST auth/change-tenant/:id`, completing the tenant switch after login.
 */
export const persistCompanySession = (
  tokenData: AuthTokenResponse,
  tenantId: string,
  companyTenantId: string
): void => {
  setAccessToken(tokenData.token);
  saveTenantId(tenantId);
  saveCompanyTenantId(companyTenantId);
  saveUserTenantId(tenantId);
};
